// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../css/colors.css'","darkOrange":"#D8630F","advantages":"AdvantagesPage_advantages__283Sp"};